module.exports = {
  footerText: `Copyright D.A.SISTEMAS INTEGRADOS © 2019-${new Date().getFullYear()}`,
}
